<template>
  <div class="main">
    <Split v-model="split" min="0" max="400">
      <div slot="left" class="demo-split-pane" style="height: 100%">
        <group-tree
          :isMore="true"
          :zsgc="true"
          :sousuo="true"
          :height="100"
          @groups="reUserGroupArr"
          @group="reGroup"
        ></group-tree>
      </div>
      <div slot="right" ref="right" style="height: 100%">
        <tem v-if="false">车辆信息</tem>
        <report-top>
          <template slot="search">
            <ly-search
              v-model="searchItem.keyword"
              @search="search"
            ></ly-search>
          </template>
        </report-top>

        <div id="formTable">
          <div class="formTableItem">
            <p class="label">单位筛选</p>
            <Input
              style="width: 200px"
              v-model="userGroupName"
              readonly
            ></Input>
          </div>
          <div class="formTableItem">
            <Button type="error" @click="getList">查询</Button>
            <Button class="chaxun" type="primary" @click="openAdd">新增</Button
            ><Button @click="exportAll" class="chaxun">导出</Button>
            <Button @click="impBtn" class="chaxun">导入</Button>
            <Button @click="getDeList(1)" class="chaxun">转移</Button>
            <Button @click="getDeList" class="chaxun">标签</Button>
          </div>
        </div>
        <Table
          border
          :columns="columns"
          :data="tableData"
          no-data-text="<div class='table-no-data'></div>"
          :height="utils.setTableHeight(200)"
          @on-selection-change="selectCars = $event"
        >
          <template slot-scope="{ row, index }" slot="picImg">
             <viewer v-if="row.pic">
              <img
                :src="axios.platConfig.fileUri + row.pic"
                width="24"
                height="24"
                style="margin-right: 4px; cursor: pointer"
              />
            </viewer>
          </template>
           <template slot-scope="{ row, index }" slot="vehicleLicensePic">
             <viewer v-if="row.vehicleLicensePic">
              <img
                :src="axios.platConfig.fileUri + row.vehicleLicensePic"
                width="24"
                height="24"
                style="margin-right: 4px; cursor: pointer"
              />
            </viewer>
          </template>

          <template slot-scope="{ row, index }" slot="action">
            <Button size="small" @click="openCarBox(row)">油箱</Button>
            <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
            <Button size="small" @click="del(row, 1)">删除</Button>
          </template>
        </Table>
        <div id="mypage">
          <div>
            <Page
              :current="1"
              :total="total"
              :page-size="searchItem.pageSize"
              :page-size-opts="[10, 50, 100]"
              show-total
              show-elevator
              show-sizer
              @on-change="changePage"
              @on-page-size-change="pageSizeChange"
            ></Page>
          </div>
        </div>
        <form-model
          :title="isAdd ? '新增车辆到' + userGroupName : '编辑车辆'"
          width="1200"
          height="340"
          ref="formModel"
          fenlei
        >
          <Select
            v-model="item.carTypeId"
            style="width: 100%"
            @on-select="selectCartype"
            slot="carTypeId"
          >
            <Avatar
              :src="
                axios.platConfig.fileUri +
                'mapicon/' +
                item.carTypeIcon +
                '/4/1.gif'
              "
              slot="prefix"
              size="small"
            />
            <Option
              :value="x.id"
              :tag="x.icon"
              v-for="(x, index) in forms[1].selectItems"
              :key="index"
              :label="x.name"
            >
              <img
                :src="
                  axios.platConfig.fileUri + 'mapicon/' + x.icon + '/4/1.gif'
                "
                width="26"
                class="tran"
                style="float: left; margin-top: -6px; margin-right: 10px"
              />
              <span>{{ x.name }}</span>
            </Option>
          </Select>
          <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
        </form-model>

        <carOilBox ref="carOilBox"></carOilBox>
        <carLabel ref="carLabel" @labelSaveFinish="getList"></carLabel>
        <Drawer title="车辆转移" :closable="false" v-model="openTransferForm">
          <div id="zhuanyi">
            <group-tree
              btn
              @queding="transferCar"
              :sousuo="true"
              v-if="openTransferForm"
            ></group-tree>
          </div>
        </Drawer>
        <daoRuWl ref="daoRuWl" @finesh="getList"></daoRuWl>
      </div>
    </Split>
  </div>
</template>
<script>
import carOilBox from "./carOilBox.vue";
import carLabel from "./carLabel.vue";
import daoRuWl from "../xiyang/common/daoRuWl.vue";
var labelList = [];
export default {
  components: { daoRuWl, carLabel, carOilBox },
  data() {
    return {
      openLabel: false,
      openForm: false,
      isAdd: false,
      split: "240",
      userGroupName: "左侧选择单位",
      openTransferForm: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "所属单位",
          key: "groupName",
          sort: 1,
        },
        {
          type: "selection",
          width: 70,
          align: "center",
          tooltip: true,
          sort: 0.5,
        },
        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 200,
          sort: 32,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
          sort: 32,
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center",
          fixed: "right",
          sort: 32,
        },
      ],
      forms: [
        {
          title: "车牌号",
          key: "carNo",
          multiple: true,
          width: 150,
          type: "Input",
          required: true,
          span: 6,
          fenlei: "基本信息",
          sort: 2,
        },
        {
          title: "车辆类型",
          key: "carTypeId",
          key2: "carTypeName",
          slotForm: "carTypeId",
          selectType: "obj",
          icon: true,
          selectItems: [],
          required: true,
          sort: 7,
          span: 6,
          fenlei: "基本信息",
        },
        {
          title: "标签分类",
          key: "labelList",
          key2: "labelList2",
          type: "Select",
          multiple: true,
          selectItems: labelList,
          sort: 9,
          span: 6,
          fenlei: "基本信息",
        },
        {
          title: "设备号",
          key: "deviceNo",
          multiple: true,
          type: "Input",
          required: true,
          readonly: false,
          span: 6,
          sort: 3,
          fenlei: "基本信息",
        },
        {
          title: "SIM卡号",
          key: "simNo",
          multiple: true,
          type: "Input",
          required: true,
          readonly: false,
          span: 6,
          sort: 4,
          fenlei: "基本信息",
        },
        {
          title: "设备类型",
          key: "deviceModel",
          type: "Select",
          selectItems: [],
          required: true,
          span: 6,
          sort: 5,
          fenlei: "基本信息",
        },
        {
          title: "设备协议",
          key: "deviceProtocol",
          type: "Select",
          selectItems: [],
          span: 6,
          sort: 6,
          fenlei: "基本信息",
        },

        {
          title: "车重/kg",
          key: "otherConfig_weight",
          type: "InputNumber",
          span: 6,
          sort: 10,
          fenlei: "基本信息",
        },
        {
          title: "车辆牌头",
          key: "brand",
          type: "Input",
          span: 6,
          sort: 11,
          fenlei: "基本信息",
        },
        {
          title: "车辆尺寸",
          key: "otherConfig_clcc",
          type: "Input",
          span: 6,
          sort: 11,
          fenlei: "基本信息",
        },
        {
          title: "内空尺寸",
          key: "otherConfig_nkcc",
          type: "Input",
          span: 6,
          sort: 11,
          fenlei: "基本信息",
        },
        {
          title: "电子关锁号",
          key: "otherConfig_dzgs",
          type: "Input",
          span: 6,
          sort: 11,
          fenlei: "基本信息",
        },
        {
          title: "海关编号",
          key: "otherConfig_hgbh",
          type: "Input",
          span: 6,
          sort: 11,
          fenlei: "基本信息",
        },
        {
          title: "车辆照片",
          key: "pic",
          slot: "picImg",
          type: "lyPhoto",
          one: true,
          sort: 23,
          span: 6,
          fenlei: "基本信息",
        },

        {
          title: "购买地址",
          key: "buyAddress",
          type: "Input",
          sort: 16,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "保管人",
          key: "custodian",
          multiple: true,
          type: "Input",
          sort: 21,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "购买日期",
          key: "buyDate",
          key2: "buyDate2",
          type: "lyyymmdd",
          sort: 15,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "注册日期",
          key: "registerDate",
          key2: "registerDate2",
          type: "lyyymmdd",
          sort: 14,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "年审日期",
          key: "annualReviewTime",
          key2: "annualReviewTime2",
          type: "lyyymmdd",
          sort: 13,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "车辆颜色",
          key: "colour",
          type: "Select",
          selectItems: [
            "黑色",
            "白色",
            "蓝色",
            "红色",
            "橙色",
            "粉色",
            "米色",
            "黄色",
            "蓝白",
            "绿白",
            "绿色",
            "其他",
          ],
          sort: 11,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "排放量",
          key: "emission",
          type: "Input",
          sort: 12,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "发动机号",
          key: "engineNo",
          key1: "engineNo",
          type: "Input",
          sort: 17,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "档案号",
          key: "fileNo",
          key1: "fileNo",
          type: "Input",
          sort: 18,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "识别码",
          key: "identifier",
          key1: "identifier",
          type: "Input",
          sort: 19,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "厂商",
          key: "firmName",
          type: "Input",
          sort: 19,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "车主",
          key: "owner",
          type: "Input",
          sort: 20,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "备注",
          key: "remark",
          type: "Input",
          sort: 23,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "服务期限",
          key: "serverTerm",
          type: "Input",
          sort: 22,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "车辆状态",
          key: "carState",
          key2: "carState2",
          type: "Select1",
          st: "carState",
          span: 6,
          sort: 8,
          fenlei: "更多车辆信息",
        },
        //  {
        //   title: "行驶证号",
        //   key: "vehicleLicenseNo",
        //   type: "Input",
        //   required: true,
        //   sort: 20,
        //   span: 6,
        //   fenlei: "更多车辆信息",
        // },
        {
          title: "行驶证照片",
          key: "vehicleLicensePic",
          slot: "vehicleLicensePic",
          type: "lyPhoto",
          required: true,
          one: true,
          sort: 23,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "行驶证到期日期",
          required: true,
          key: "vehicleLicenseValidTime",
          key2: "vehicleLicenseValidTime",
          type: "lyyymmdd",
          sort: 15,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: " 商业险到期日期",
          required: true,
          key: "commercialInsuranceExpiryDate",
          key2: "commercialInsuranceExpiryDate",
          type: "lyyymmdd",
          sort: 15,
          span: 6,
          fenlei: "更多车辆信息",
        },
        {
          title: "交强险到期日期",
          required: true,
          key: "compulsoryInsuranceExpiryDate",
          key2: "compulsoryInsuranceExpiryDate",
          type: "lyyymmdd",
          sort: 15,
          span: 6,
          fenlei: "更多车辆信息",
        },
      ],
      tableData: [],
      item: {
        carNo: "",
        id: 0,
        carTypeId: "",
        carTypeIcon: "arrow",
        deviceId: 0,
        deviceNo: "",
        deviceModel: "",
        simNo: "",
        groupId: "",
        groupName: "",
        labelList: [],
        pic:"",
        otherConfig_weight: 0,
        otherConfig_dzgs: "",
        otherConfig_hgbh: "",
        otherConfig_clcc: "",
        otherConfig_nkcc: "",
        otherConfig: {},
        otherConfigObj: {},
        //buyDate:Date.now()
      },

      carTypeList: [],
      deviceTypeList: [],
      searchItem: {
        keyword: "",
        pageSize: 50,
        pageNumber: 1,
        groupIdList: [],
      },
      total: 0,
      selectCars: [],

      imp: {
        temUrl: this.axios.ipPort + "/cloud-common-server-dm/car3/tmpl",
        url: this.axios.ipPort + "/cloud-common-server-dm/car3/imp",
      },
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dm + "/car/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log("cheliang", data);
        for (let i = 0; i < data.length; i++) {
          data[i].labelList2 = data[i].labelList.join(",");
          data[i].carState2 = this.$t("carState." + data[i].carState);
          data[i].carState = String(data[i].carState);
          data[i].buyDate2 = this.utils.time(data[i].buyDate, "yymmdd");
          data[i].registerDate2 = this.utils.time(
            data[i].registerDate,
            "yymmdd"
          );
          data[i].annualReviewTime2 = this.utils.time(
            data[i].annualReviewTime,
            "yymmdd"
          );
          data[i].otherConfigObj =
            data[i].otherConfig == null
              ? { weight: 0, clcc: "", nkcc: "", dzbh: "" }
              : JSON.parse(data[i].otherConfig);
          /*data[i].otherConfig_weight = data[i].otherConfig.weight; */
          var t = data[i].otherConfigObj;
          for (const j in t) {
            data[i]["otherConfig_" + j] = t[j];
          }
        }

        this.tableData = data;
      });
    },
    exportAll() {
      var params = [
        {
          name: "keyword",
          value: this.searchItem.keyword,
        },
        {
          name: "groupIdList",
          value: this.searchItem.groupIdList,
        },
      ];
      this.utils.exportData(this.axios.dm + "/car/export", params);
    },
    impBtn() {
      this.$refs.daoRuWl.openWin(this.imp);
    },
    addUpdate(name) {
      console.log(this.item);
      var m = this.$refs.formModel.getItem();
      if (!m) {
        return;
      }
      this.toObj();
      let a = JSON.stringify(this.item.otherConfigObj);
      this.item.otherConfig = a;

      //判断设备号，卡号，设备类型，有其中之一填写则需要全部填写


      this.item.device = {
        deviceNo: this.item.deviceNo ? this.item.deviceNo : "",
        simNo: this.item.simNo ? this.item.simNo : "",
        model: this.item.deviceModel ? this.item.deviceModel : "",
        protocol: this.item.deviceProtocol ? this.item.deviceProtocol : "",
      };
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.dm + "/car/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.dm + "/car/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    toObj() {
      this.item.otherConfigObj.weight = this.item.otherConfig_weight;
      this.item.otherConfigObj.clcc = this.item.otherConfig_clcc;
      this.item.otherConfigObj.dzgs = this.item.otherConfig_dzgs;
      this.item.otherConfigObj.hgbh = this.item.otherConfig_hgbh;
      this.item.otherConfigObj.nkcc = this.item.otherConfig_nkcc;
    },
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.dm + "/car/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.openForm = false;
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.setDisabled();
      //this.item = JSON.parse(JSON.stringify(row));
      // for (const i in row) {
      //   this.item[i] = row[i];
      // }
      this.item = row

      //this.item.deviceNo='14838031143';
      //this.item.simNo='1454317865';
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      console.log(this.item);

      if (this.utils.isEmpty(this.item.groupId)) {
        this.$Message.error({
          content: "请先在左边选择目标单位（不能选多个）",
          duration: 5,
        });
        return;
      }
      this.isAdd = true;
      //this.setDisabled();
      this.$refs.formModel.reach(this.forms, this.item);
    },
    setDisabled() {
      var data = this.forms;
      for (let i = 0; i < data.length; i++) {
        if (data[i].key == "deviceNo" || data[i].key == "simNo") {
          if (this.isAdd) {
            data[i].readonly = false;
          } else {
            data[i].readonly = true;
          }
        }
      }
    },
    chaxun() {
      this.getList();
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    reDevice(v) {
      this.item.deviceNo = v.deviceNo;
      this.item.deviceId = v.id;
      this.openDevice = false;
    },
    getCarTypeList() {
      this.axios({
        method: "post",
        url: this.axios.dm + "/carType/list",
        data: {},
      }).then((res) => {
        var data = res.data.data.dataList;
        this.forms[1].selectItems = data;
      });
    },
    selectCartype(x) {
      console.log(x);
      this.item.carTypeIcon = x.tag;
    },
    openCarBox(v) {
      this.$refs.carOilBox.reachData(v);
    },

    search() {
      this.getList();
    },
    //多选模式下。将选中的放到deList里边,目前批量转移接用
    getDeList(y) {
      var x = this.selectCars;
      if (x.length == 0) {
        this.$Message.error("至少选择一台车");
        return;
      }
      if (y == 1) {
        this.openTransferForm = true;
      } else {
        this.$refs.carLabel.reachData(x);
      }
    },
    transferCar(v) {
      var idList = [],
        a = this.selectCars;
      for (let i = 0; i < a.length; i++) {
        idList[i] = a[i].id;
      }
      this.axios({
        method: "post",
        url: this.axios.dm + "/car/shift",
        data: {
          groupId: v[0].id,
          idList: idList,
        },
      }).then((res) => {
        console.log(res);
        if (res) {
          this.openTransferForm = false;
          this.getList();
          this.selectCars = [];
        }
      });
    },
    getDictionary() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "deviceModel",
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = JSON.parse(res.data.data.value);
        var arr = [];
        for (let i = 0; i < data.length; i++) {
          arr.push(data[i].name);
        }
        this.forms[5].selectItems = arr;
      });
    },
    getDictionary1() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "deviceProtocol",
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = JSON.parse(res.data.data.value);
        var arr = [];
        for (let i = 0; i < data.length; i++) {
          arr.push(data[i].name);
        }
        this.forms[6].selectItems = arr;
      });
    },
    getDictionary2() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "carLabel",
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        var list = JSON.parse(res.data.data.value);
        labelList.splice(0, 100);
        for (let i = 0; i < list.length; i++) {
          labelList.push(list[i].name);
        }
      });
    },
    reUserGroupArr(v) {
      this.searchItem.groupIdList = [];
      for (const i in v) {
        this.searchItem.groupIdList.push(v[i].id);
      }
      this.item.groupId = "";
      if (v.length == 1) {
        this.userGroupName = v[0].title;
        this.item.groupId = v[0].id;
      } else if (v.length > 1) {
        this.userGroupName = "共查看" + v.length + "个单位";
      } else if (v.length == 0) {
        this.userGroupName = "未选择任何单位";
      }
      this.getList();
    },
    reGroup(x, y) {
      this.reUserGroupArr(y);
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.chaxun();
    this.getCarTypeList();
    this.getDictionary();
    this.getDictionary1();
    this.getDictionary2();
  },
};
</script>
<style>
#zhuanyi {
  height: calc(100% - 110px);
}
</style>



// WEBPACK FOOTER //
// src/components/information/truck.vue